var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000019666308414107203810000016359489542308255153_",
    transform: "translate(0 0.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "croos",
    transform: "translate(0 -0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31446",
    "data-name": "Path 31446",
    d: "M4.451,3.4,6.8,1.049A.673.673,0,0,0,5.853.1h0L3.5,2.448,1.148.1A.673.673,0,0,0,.2,1.049L2.548,3.4.2,5.752a.673.673,0,0,0,.951.951L3.5,4.352,5.85,6.7A.673.673,0,0,0,6.8,5.752Z",
    transform: "translate(0 0.1)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/close_white.aa973157b496b6e6ffaa5ad354ba8b57.svg";
export { ForwardRef as ReactComponent };